import React from "react";
import { motion } from "framer-motion";
import { UserRound, Sparkles, Handshake } from "lucide-react";

const STEPS = [
  {
    icon: UserRound,
    title: "Crée ton profil",
    text: "En moins de 2 minutes. Dis-nous où tu en es dans ton aventure de maman — grossesse, post-partum, sommeil, allaitement.",
  },
  {
    icon: Sparkles,
    title: "Découvre des mamans qui te ressemblent",
    text: "Notre matching prend en compte ta ville, l'âge de ton enfant et l'étape que tu traverses vraiment.",
  },
  {
    icon: Handshake,
    title: "Match, discute, rencontre",
    text: "Écrivez-vous, partagez, puis retrouvez-vous IRL — café, parc, ou lors d'un événement MamaMatch près de chez toi.",
  },
];

const EASE = [0.2, 0.7, 0.2, 1];

export default function HowItWorks() {
  return (
    <section
      id="comment"
      data-testid="how-it-works-section"
      className="relative py-20 md:py-32 bg-white"
    >
      <div className="mx-auto max-w-[1280px] px-5 md:px-8">
        <div className="max-w-[720px] mb-14 md:mb-20">
          <motion.p
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6 }}
            className="text-[13px] font-semibold uppercase tracking-[0.14em] text-[#D97757]"
          >
            Fonctionnement
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, ease: EASE }}
            className="mt-4 font-display text-[32px] sm:text-[42px] md:text-[52px] text-[#0A0A0A]"
          >
            Trois gestes simples, une vraie communauté.
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.article
                key={s.title}
                data-testid={`step-0${i + 1}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.8, ease: EASE, delay: i * 0.08 }}
                className="mm-card p-8 md:p-10 flex flex-col h-full"
              >
                <div className="flex items-center gap-3 mb-8">
                  <span className="text-[13px] font-semibold text-[#0A0A0A]/40">
                    0{i + 1}
                  </span>
                  <span className="flex-1 h-px bg-[rgba(10,10,10,0.08)]" />
                  <Icon
                    className="w-5 h-5 text-[#0A0A0A]"
                    strokeWidth={1.5}
                  />
                </div>
                <h3 className="font-display text-[22px] md:text-[26px] leading-[1.15] text-[#0A0A0A]">
                  {s.title}
                </h3>
                <p className="mt-4 text-[15px] leading-[1.55] text-[#6B6660]">
                  {s.text}
                </p>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
